import { useEffect, useRef } from 'react';
import { api } from '@/lib/api';
import { resolveActiveTenantId } from '@/lib/tenant-context';
import { useAuthStore } from '@/stores/auth-store';
import type { User } from '@/types';

export function useSessionProfileSync() {
  const isAuthenticated = useAuthStore(s => s.isAuthenticated);
  const user = useAuthStore(s => s.user);
  const setUser = useAuthStore(s => s.setUser);
  const logout = useAuthStore(s => s.logout);
  const hasStartedRef = useRef(false);

  useEffect(() => {
    if (!isAuthenticated || user || hasStartedRef.current) {
      return;
    }

    hasStartedRef.current = true;

    const activeTenantId = resolveActiveTenantId(user);

    void api
      .get<User>('/auth/me', {
        headers: activeTenantId
          ? {
              'X-Tenant-Id': activeTenantId,
            }
          : undefined,
      })
      .then(response => {
        setUser(response.data);
      })
      .catch((error: any) => {
        if (error?.response?.status === 401) {
          void logout(false);
        }
      });
  }, [isAuthenticated, logout, setUser, user]);
}
